/* Header: keeps --header-top/--header-bottom current for menus and search, fades the phone search row once
   the sticky header is pinned, and re-runs the desktop menu fit (LMB.fitHeader, defined inline in
   sections/header.liquid): tighter spacing first, then the compact layout with a Menu button. */
if (!customElements.get('lmb-header')) {
  const DESKTOP = window.matchMedia('(min-width: 1100px)');

  customElements.define(
    'lmb-header',
    class LmbHeader extends HTMLElement {
      connectedCallback() {
        LMB.trackHeader(this.querySelector('.header__bar'));

        this.fit = this.fit.bind(this);
        this.inner = this.querySelector('.header__inner');
        this.list = this.querySelector('.header__nav-list');
        this.utils = this.querySelector('.header__utils');
        this.logo = this.querySelector('.header__logo');
        this.resizeObserver = new ResizeObserver(this.fit);
        [this.inner, this.list, this.utils, this.logo].forEach((el) => el && this.resizeObserver.observe(el));
        DESKTOP.addEventListener('change', this.fit);
        if (document.fonts) document.fonts.ready.then(this.fit);
        this.fit();

        if (this.dataset.sticky === 'always' && this.querySelector('.header__search-row')) {
          this.onScroll = () => {
            const pinned = window.scrollY > 0 && this.getBoundingClientRect().top <= 0;
            this.classList.toggle('is-condensed', pinned);
          };
          window.addEventListener('scroll', this.onScroll, { passive: true });
          this.onScroll();
        }
      }

      disconnectedCallback() {
        if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
        if (this.resizeObserver) this.resizeObserver.disconnect();
        DESKTOP.removeEventListener('change', this.fit);
      }

      get isCompact() {
        return this.classList.contains('is-compact');
      }

      fit() {
        const wasCompact = this.isCompact;
        const compact = typeof LMB.fitHeader === 'function' ? LMB.fitHeader(this) : false;
        if (compact === wasCompact) return;
        document.dispatchEvent(new CustomEvent('lmb:header-layout', { detail: { compact } }));
      }
    }
  );
}
